<template>
    <v-container>
        <v-row align="center" justify="center">
            <h1 class="display-1 mb-3 mt-3" style="color: #084776">Priručnici i upute za korištenje</h1>
            <v-col cols="10" v-for="(item, i) in prirucnici" :key="i">
                <v-card outline class="my-2 px-10 py-8" :href="item.link" target="_blank" hover>
                    <v-layout row wrap align-center>
                        <v-flex xs11>
                            <h2 style="color: #084776">{{item.title}}</h2>
                            <v-card-subtitle style="color: #8a8a8a">{{item.text}}</v-card-subtitle>
                        </v-flex>
                        <v-flex xs1>
                            <v-icon color="#084776">fas fa-chevron-right</v-icon>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        prirucnici: [
          {
            link: "https://eucenje.sum.ba/Prirucnik/mobile/index.html#p=1",
            title: "Moodle džepni priručnik",
            text: "Kliknite ovdje za pregled"
          },
          {
            link: "https://eucenje.sum.ba/Prirucnik/prirucnik-nastavnici.pdf",
            title: "Priručnik za nastavnike",
            text: "Kliknite ovdje za pregled"
          },
          {
            link: "https://eucenje.sum.ba/Prirucnik/prirucnik-studenti.pdf",
            title: "Priručnik za studente",
            text: "Kliknite ovdje za pregled"
          },
          {
            link: 'https://web-admin.sum.ba/api/storage/Upute%20za%20kreiranje%20e%20kolegija_1579595159_42.pdf',
            title: 'Upute za kreiranje e-kolegija',
            text: "Kliknite ovdje za pregled"
          },
          {
            link: 'https://eucenje.sum.ba/Prirucnik/Prepruke-za-obrazovne-materijale-u-otvorenom-pristupu.pdf',
            title: 'Prepruke za obrazovne materijale',
            text: "Kliknite ovdje za pregled"
          },
          {
            link: 'https://eucenje.sum.ba/Prirucnik/Prirucnik-za-izradu-testova-u-sustavu-SUMARUM.pdf',
            title: 'Priručnik za izradu testova',
            text: "Kliknite ovdje za pregled"
          },
          {
            link: 'https://eucenje.sum.ba/Prirucnik/Upute-za-pristup-online-tecajevima-u-sustavu-SUMARUM.pdf',
            title: 'Upute za pristup online tečajevima',
            text: "Kliknite ovdje za pregled"
          },
          {
            link: 'https://www.youtube.com/watch?v=C2zcvYh5FRE',
            title: 'Organizacija i sadržaj e-kolegija',
            text: "Kliknite ovdje za pregled"
          },
          {
            link: 'https://www.youtube.com/channel/UCzjzEJSfK2fuBkitcDV5-0w',
            title: 'Video upute',
            text: "Kliknite ovdje za pregled"
          }
        ]
    })
}
</script>